import React from 'react';
import { IIconProps } from './utils';

export const DownloadExcel = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 16 17" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M8.50488 1.16699C8.88947 1.16704 9.26597 1.25099 9.60938 1.40723C9.89709 1.53822 10.1628 1.72042 10.3906 1.94824L13.2197 4.77637C13.4475 5.00424 13.6298 5.26991 13.7607 5.55762C13.9169 5.90096 14 6.27761 14 6.66211V13.167C13.9998 14.6393 12.8063 15.8336 11.334 15.834H4.66699C3.19437 15.834 2.00022 14.6396 2 13.167V12.501C2 12.1328 2.2988 11.834 2.66699 11.834C3.03503 11.8342 3.33398 12.1329 3.33398 12.501V13.167C3.3342 13.9032 3.93075 14.501 4.66699 14.501H11.334C12.0699 14.5006 12.6668 13.903 12.667 13.167V6.66211C12.6669 6.47002 12.6249 6.28196 12.5469 6.11035C12.5022 6.01212 12.4446 5.91934 12.377 5.83398H10C9.63181 5.83398 9.33301 5.53518 9.33301 5.16699V2.78906C9.24795 2.72146 9.15546 2.66468 9.05762 2.62012C8.88588 2.54197 8.69714 2.50102 8.50488 2.50098H4.66699C3.93061 2.50098 3.33398 3.0976 3.33398 3.83398V9.83398C3.33376 10.2019 3.0349 10.5008 2.66699 10.501C2.29894 10.501 2.00022 10.202 2 9.83398V3.83398C2 2.36123 3.19423 1.16699 4.66699 1.16699H8.50488Z"
      fill={fill}
    />
    <path
      d="M9.77441 12.7173L6.2527 8.62378"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M6.22554 12.7173L9.74732 8.62381"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
